import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { SavedProvider } from "@/context/SavedContext";
import { MatchCelebrationProvider } from "@/context/MatchCelebration";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Onboarding from "@/pages/Onboarding";
import Discovery from "@/pages/Discovery";
import SearchPage from "@/pages/SearchPage";
import ProfileDetail from "@/pages/ProfileDetail";
import Matches from "@/pages/Matches";
import Saved from "@/pages/Saved";
import MyProfile from "@/pages/MyProfile";
import Premium from "@/pages/Premium";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Settings from "@/pages/Settings";
import Stories from "@/pages/Stories";
import Notifications from "@/pages/Notifications";
import AICoach from "@/pages/AICoach";
import Invite from "@/pages/Invite";
import LegalPage from "@/pages/LegalPage";
import MarriageBoard from "@/pages/MarriageBoard";
import BoardAdmin from "@/pages/BoardAdmin";
import FamilyView from "@/pages/FamilyView";
import FamilyMode from "@/pages/FamilyMode";
import AssistedMatchmaking from "@/pages/AssistedMatchmaking";
import WaliReview from "@/pages/WaliReview";
import AssistBrowse from "@/pages/AssistBrowse";
import Safety from "@/pages/Safety";
import Faq from "@/pages/Faq";
import About from "@/pages/About";

const Protected = ({ children, requireProfile = true }) => (
  <ProtectedRoute requireProfile={requireProfile}>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <SavedProvider>
          <MatchCelebrationProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/privacy" element={<LegalPage doc="privacy" />} />
            <Route path="/terms" element={<LegalPage doc="terms" />} />
            <Route path="/community" element={<LegalPage doc="community" />} />
            <Route path="/marriage-board" element={<MarriageBoard />} />
            <Route path="/marriage-board/admin" element={<BoardAdmin />} />
            <Route path="/family-view/:token" element={<FamilyView />} />
            <Route path="/onboarding" element={<ProtectedRoute requireProfile={false}><Onboarding /></ProtectedRoute>} />
            <Route path="/discovery" element={<Protected><Discovery /></Protected>} />
            <Route path="/search" element={<Protected><SearchPage /></Protected>} />
            <Route path="/profiles/:id" element={<Protected><ProfileDetail /></Protected>} />
            <Route path="/matches" element={<Protected><Matches /></Protected>} />
            <Route path="/saved" element={<Protected><Saved /></Protected>} />
            <Route path="/profile" element={<Protected><MyProfile /></Protected>} />
            <Route path="/premium" element={<Protected><Premium /></Protected>} />
            <Route path="/payment/success" element={<Protected><PaymentSuccess /></Protected>} />
            <Route path="/settings" element={<Protected><Settings /></Protected>} />
            <Route path="/stories" element={<Protected><Stories /></Protected>} />
            <Route path="/ai-coach" element={<Protected><AICoach /></Protected>} />
            <Route path="/invite" element={<Protected><Invite /></Protected>} />
            <Route path="/family-mode" element={<Protected><FamilyMode /></Protected>} />
            <Route path="/assisted" element={<Protected><AssistedMatchmaking /></Protected>} />
            <Route path="/assist/member/:memberId" element={<Protected><WaliReview /></Protected>} />
            <Route path="/assist/browse" element={<ProtectedRoute requireProfile={false}><AssistBrowse /></ProtectedRoute>} />
            <Route path="/safety" element={<Protected><Safety /></Protected>} />
            <Route path="/faq" element={<Protected><Faq /></Protected>} />
            <Route path="/about" element={<Protected><About /></Protected>} />
            <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
          </Routes>
          </MatchCelebrationProvider>
          </SavedProvider>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
